import React from 'react';
import BaseComponent from "../../../../gd-components/base-component/base-component";

import Popover from "../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../gd-components/gd-popover/@const";
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import Search from '../../../../gd-components/popover-menu/search/search';

import Classes from 'classnames';

import Option from "./option";

type Props = {
    options                 : any[]                            // yes options not items ... better name
    optionType?             : 'text' | 'icon-text'

    placeholder?             : string
    disabled?                 : boolean                          // do we need it ?

    // look and feel
    size?                    : 'big'                             // big small 36 / 30

    // this is value (not clicked current value)
    renderValue?             : 'text' | 'icon-text' | 'func'     // render value view name
    renderValueFunc?         : func                              // func for external render function if passwed used to render instead of default
    renderOptionFunc?        : func
    emptyRenderer?           : func

    currentValue?            : any                               // curent select element value
    multiselect?             : boolean

    // advanced options
    searchable?              : boolean
    keyboardNavigation?      : boolean

    showHelp?                : boolean
    manageLabel?             : string

    // Callbacks
    onUserSelect?            : callback
    onOptionSelect           : callback
    onManageOptions?         : callback

    hidePopover?             : callback
    onTogglePopover?         : callback
    popoverFitTargetWidth?  : boolean
    popoverStyle?            : any
    popoverClass?            : string
    popoverContentClass?    : string
    outsideClickIgnoreClass?: string

    // Popover position
    attachmentType?          : PopoverAttachmentType | 'full' | 'vertical' | 'horizontal'
    attachment?              : string
    targetAttachment?        : string
    targetOffset?            : string
    scrollContentStyle?      : any
}

type State = {
    searchString      : string | null
    currentCursorKey  : number
}

class PopoverSelect extends BaseComponent {

    declare props: Props
    declare state: State

    static defaultProps: Partial<Props> = {
        attachmentType: PopoverAttachmentType.FULL,
        attachment: "top center",
        targetAttachment: "bottom center",
        targetOffset: "-3px 0", // -3px to make it appear right under the line

        renderValue: 'text',

        popoverFitTargetWidth: true,

        searchable: true,
        keyboardNavigation: false
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            searchString: null,
            currentCursorKey: 0 // - not in use at the moment
        };

        this._bind('onSearchChange','handleSelectItem');

    }

    // Not in use at the moment - there are too many issues here
    onPopoverKeyDown(event:any) {
        return false;
    }

    onSearchChange(newValue:string) {
        this.setState({
            searchString: newValue
        });
    }

    handleSelectItem(item:any){
        this.props.onOptionSelect(item.value);
    }

    render() {

        let content;
        let optionsToDisplay = this.props.options.slice();
        optionsToDisplay = _.filter(optionsToDisplay, option=>!option.notSelectable);

        // filter if search enabled
        if (this.props.searchable && this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase()
            optionsToDisplay = _.filter(optionsToDisplay.slice(), i=>i.label.toString().toLowerCase().includes(searchString))
        }

        if (optionsToDisplay && optionsToDisplay.length>0) {
            content = (
                <VScroll minDragHeight={10} style={this.props.scrollContentStyle}>
                    <div className="gd-select-group gd-popup-menu-items s-13">
                        {optionsToDisplay.map((item, key)=>{

                            const isSelected = (this.props.multiselect)
                                ?this.props.currentValue.includes(item.value)
                                :item.value === this.props.currentValue;

                            const selectClass = Classes("action", {
                                'selected': isSelected,
                                'cursor-position': this.props.keyboardNavigation && this.state.currentCursorKey === key
                            });

                            return <Option className={selectClass}
                                                       key={item.value || item.label}
                                                       multiselect={this.props.multiselect}
                                                       item={item}
                                                       onItemSelected={this.handleSelectItem}
                                                       renderFunc={this.props.renderOptionFunc}
                                                        isSelected={isSelected}
                            />;
                        })}
                    </div>
                </VScroll>
            );
        } else {
            content = (
                <div className="nothing-found" onClick={this.props.hidePopover}>
                    {this.props.emptyRenderer ? this.props.emptyRenderer() : "Nothing found"}
                </div>
            );
        }

        const popoverClasses = Classes("gd-select-new-popover", this.props.popoverClass, {
            'with-help': !!this.props.onManageOptions
        })

        const popoverPosition = new PopoverPosition({
            attachmentType  : this.props.attachmentType as PopoverAttachmentType,
            attachment      : this.props.attachment,
            targetAttachment: this.props.targetAttachment,
            targetOffset    : this.props.targetOffset,
        })

        return (
            <Popover popoverClass={popoverClasses}
                     className={this.props.popoverContentClass}
                     position={popoverPosition}
                     onKeyDown={this.onPopoverKeyDown}
                     onClickOutside={()=>{if (this.props.hidePopover) this.props.hidePopover()}}
                     outsideClickIgnoreClass={this.props.outsideClickIgnoreClass}
                     fitTargetWidth={this.props.popoverFitTargetWidth}
                     style={this.props.popoverStyle}>

                {this.props.searchable && this.props.options && this.props.options.length>10 &&
                <Search searchString={this.state.searchString} onSearch={this.onSearchChange} onEscapePressed={this.props.hidePopover}/>}

                {content}

                {this.props.showHelp &&
                <div className="help">
                    <div className="ui5-link-small" onClick={this.props.onManageOptions}>{this.props.manageLabel}</div>
                </div>}
            </Popover>
        );
    }
}

export default PopoverSelect;
